import React from "react";
import { Select, Text } from "@telia/teddy";
import { PhoneNumberFormatters } from "../../../../app/utils";
import TEXT from "../../../text-consts";
import "./NewNumberPanel.less";
const { PHONENUMBER, VERIFICATION } = TEXT.PERSONAL_DETAILS;

export interface NewNumberPanelProps {
    availablePhoneNumbers: string[];
    choosePhoneNumber: (phoneNumber: string, isSubscriptionBroadband: boolean) => void;
    disabled: boolean;
    hideNewPhoneNumberArea: boolean;
    hideNewPhoneNumberAreaMessage: string;
    isFetchingNumbers: boolean;
    isSubscriptionBroadband: boolean;
    isSubscriptionPrepaid: boolean;
    labelId: string;
    selectedPhoneNumber: string;
    subscriptionId: string;
}

const NewNumberPanel: React.FC<NewNumberPanelProps> = ({
    availablePhoneNumbers,
    choosePhoneNumber,
    hideNewPhoneNumberArea,
    hideNewPhoneNumberAreaMessage = VERIFICATION.NEW_NUMBER_ABOVE_LIMIT,
    isFetchingNumbers,
    labelId,
    selectedPhoneNumber,
    isSubscriptionBroadband,
}) => {
    const formatter = isSubscriptionBroadband ? PhoneNumberFormatters[3].displayFn : PhoneNumberFormatters[0].displayFn;

    return (
        <>
            {hideNewPhoneNumberArea && (
                <>
                    <br />
                    <Text mb="100" variant="additional-100">
                        {hideNewPhoneNumberAreaMessage}
                    </Text>
                </>
            )}
            {isFetchingNumbers && !hideNewPhoneNumberArea && (
                <>
                    <br />
                    <Text mb="100" variant="additional-100">
                        {PHONENUMBER.FETCHING_NUMBERS}
                    </Text>
                </>
            )}

            {!isFetchingNumbers && availablePhoneNumbers.length > 0 && !hideNewPhoneNumberArea && (
                <div className="beta-checkout__number-picker__dropdown-wrapper">
                    {availablePhoneNumbers.length > 0 && (
                        <Select
                            name="new-phone-number"
                            options={availablePhoneNumbers}
                            value={(selectedPhoneNumber || availablePhoneNumbers[0])?.replace(/\s/g, "")}
                            onValueChange={(value) => {
                                choosePhoneNumber(value, isSubscriptionBroadband);
                                return value;
                            }}
                            className="new-number-panel__select"
                        >
                            <Select.Trigger aria-labelledby={labelId} className="new-number-panel__select-trigger">
                                <Select.Value
                                    placeholder={formatter(
                                        (selectedPhoneNumber || availablePhoneNumbers[0] || "").replace(/\s/g, ""),
                                    )}
                                />
                            </Select.Trigger>
                            <Select.Content data-di-mask>
                                <Select.Viewport>
                                    {availablePhoneNumbers.map((number) => (
                                        <Select.Item key={number} value={number}>
                                            {formatter(number)}
                                        </Select.Item>
                                    ))}
                                </Select.Viewport>
                            </Select.Content>
                        </Select>
                    )}
                </div>
            )}
        </>
    );
};

export default NewNumberPanel;
